import React from "react"
import { Paper, Box, makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  selected: {
    border: `2px solid ${theme.palette.cards.selected.borderColor}`,
  },
  completed: {
    backgroundColor: theme.palette.cards.completed.backgroundColor,
    border: `2px solid ${theme.palette.cards.completed.borderColor}`,
  },
  overdue: {
    border: `2px solid ${theme.palette.cards.overdue.borderColor}`,
  },
  skipped: {
    backgroundColor: theme.palette.cards.skipped.backgroundColor,
    border: `2px solid ${theme.palette.cards.skipped.borderColor}`,
  },
}))

const PaperBox = ({
  children,
  elevation = 3,
  fullWidth = false,
  fullHeight = false,
  selected,
  completed,
  skipped,
  overdue,
  paperProps,
  className = "",
  ...props
}) => {
  const classes = useStyles()

  return (
    <Paper
      elevation={elevation}
      style={{ width: fullWidth ? "100%" : null, height: fullHeight ? "100%" : null }}
      className={`${className} ${selected ? classes.selected : ""} ${completed ? classes.completed : ""} ${
        overdue ? classes.overdue : ""
      } ${skipped ? classes.skipped : ""}`.trim()}
      {...paperProps}
    >
      <Box {...props}>{children}</Box>
    </Paper>
  )
}

export { PaperBox }
